import { createBrowserRouter } from "react-router-dom";

import * as Layouts from "@src/layouts";
import * as Pages from "@src/pages";
import { paths } from "./paths";

import { SHOW_FOOTER as showFooter } from "../config";
import { SHOW_HEADER as showHeader } from "../config";

const routes = [
  {
    element: (
      <Layouts.MainLayout
        primary
        showHeader={showHeader}
        showFooter={showFooter}
      />
    ),
    children: [
      {
        path: paths.root,
        errorElement: (
          <Layouts.BaseLayout primary withScrollRestoration={false}>
            <Pages.AppErrorPage />
          </Layouts.BaseLayout>
        ),
        children: [
          {
            element: (
              <Layouts.BaseLayout primary>
                <Pages.NotFoundPage />
              </Layouts.BaseLayout>
            ),
            path: "*",
          },
          {
            index: true,
            errorElement: <Pages.RouteErrorPage />,
            element: <Pages.HomePage />,
            handle: {
              shouldSavePreviousPaths: true,
            },
          },
          {
            path: paths.output,
            errorElement: <Pages.RouteErrorPage />,
            element: <Pages.HomePage output={true} />,
            children: [
              {
                element: (
                  <Layouts.BaseLayout primary>
                    <Pages.NotFoundPage />
                  </Layouts.BaseLayout>
                ),
                path: "*",
              },
              {
                index: true,
                errorElement: <Pages.RouteErrorPage />,
                element: <Pages.HomePage output={true} />,
                handle: {
                  shouldSavePreviousPaths: true,
                },
              },
            ],
          },
          {
            path: paths.offtarget,
            errorElement: <Pages.RouteErrorPage />,
            element: <Pages.HomePage offtarget={true} />,
            children: [
              {
                element: (
                  <Layouts.BaseLayout primary>
                    <Pages.NotFoundPage />
                  </Layouts.BaseLayout>
                ),
                path: "*",
              },
              {
                index: true,
                errorElement: <Pages.RouteErrorPage />,
                element: <Pages.HomePage offtarget={true} />,
                handle: {
                  shouldSavePreviousPaths: true,
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export { router, routes };
